import { event_log } from '@axo/shared/data-access/types';

export interface ILoanApplicationEventsKeyParams {
  find?: event_log.Find;
  cursor?: string;
}

export const loanApplicationEventsKeys = {
  root: (params: ILoanApplicationEventsKeyParams) =>
    [
      'loan application events',
      'find',
      params.find,
      'cursor',
      params.cursor,
    ] as const,
};

export function parseLoanApplicationEventsKey<
  T extends keyof typeof loanApplicationEventsKeys
>(
  queryKey: ReturnType<(typeof loanApplicationEventsKeys)[T]>
): ILoanApplicationEventsKeyParams {
  const [, , find, , cursor] = queryKey;

  return {
    find,
    cursor,
  };
}
